import ApiService from "../../../../services/ApiService";
import { formatDatePickerValue, normalizeDate } from "../../../../services/TimeService";
import translate from "../../../../services/Translate";
import { DiplomaRegenerateForm } from "./UserDocuments.d";

const _DIPLOMA_REGENERATE_ERRORS: Record<string, string> = {
  "is not a diploma": "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.NOT_A_DIPLOMA",
  "missing birthdate": "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.MISSING_BIRTHDATE",
  "missing is_mines": "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.MISSING_IS_MINES",
  "missing is_ece": "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.MISSING_IS_ECE",
  "regeneration failed": "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.REGENERATION_FAILED",
};

export const fetchUserDocuments = (userId: number, setDocuments: Function, setLoading: Function) => {
  setLoading(true);

  ApiService.get(`users/${userId}/documents`)
    .then((response) => setDocuments(response.data.documents))
    .catch((error) => console.error("An error occurred while fetching user's documents", error))
    .finally(() => setLoading(false));
};

export const getDiplomaFormValues = (document: any): DiplomaRegenerateForm => {
  const stored = typeof document.parameters === "string" ? JSON.parse(document.parameters) : document.parameters || {};

  return {
    name: stored.name || "",
    birthdate: stored.birthdate ? normalizeDate(stored.birthdate) : "",
    date: stored.date ? normalizeDate(stored.date) : "",
    is_mines: stored.is_mines_diploma ?? stored.is_mines ?? false,
    is_ece: stored.is_ece_diploma ?? stored.is_ece ?? false,
    language: stored.language,
    send_email: true,
  };
};

export const regenerateDiploma = (
  language: string,
  documentId: number,
  form: DiplomaRegenerateForm,
  setSubmitting: Function,
  callback?: Function
) => {
  setSubmitting(true);

  ApiService.post(`documents/diplomas/${documentId}/regenerate`, {
    name: form.name.trim() || undefined,
    birthdate: form.birthdate ? formatDatePickerValue(form.birthdate) : undefined,
    date: form.date ? formatDatePickerValue(form.date) : undefined,
    is_mines: form.is_mines,
    is_ece: form.is_ece,
    language: form.language,
    send_email: form.send_email,
  })
    .then((_) => {
      alert(
        translate(
          language,
          form.send_email
            ? "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.SUCCESS_EMAIL"
            : "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.SUCCESS"
        )
      );
      callback?.();
    })
    .catch((err) => {
      console.error("An error occurred during diploma regeneration", err);
      const apiMessage = err?.data?.error?.message;

      if (typeof apiMessage === "string" && apiMessage.includes("erratum email failed")) {
        alert(translate(language, "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.EMAIL_FAILED"));
        callback?.();
        return;
      }

      const matchedKey =
        typeof apiMessage === "string"
          ? Object.keys(_DIPLOMA_REGENERATE_ERRORS).find((key) => apiMessage.includes(key))
          : undefined;

      alert(
        translate(
          language,
          matchedKey ? _DIPLOMA_REGENERATE_ERRORS[matchedKey] : "PAGES.USER.DOCUMENT_TABLE.EDIT_DIPLOMA.ERROR.GENERIC"
        )
      );
    })
    .finally(() => setSubmitting(false));
};
